// Pure helpers for lesson tabs transcript/bookmark visibility.
// Covered by CI `yarn test:js` and:
//   node --test app/components/community/courses/lesson_tabs_helpers.test.mjs

/**
 * Coerce a media asset id from play events / Stimulus params / dataset
 * attributes to a finite number. Returns null when the value is missing
 * or not numeric so callers can no-op instead of wrongly hiding tabs.
 */
export function normalizeAssetId(assetId) {
  if (assetId == null || assetId === '') return null
  const n = Number(assetId)
  return Number.isFinite(n) ? n : null
}

/**
 * Whether the given asset id (string or number) is in the list of asset ids
 * that have a transcript. Both sides are normalized so `"123"` matches `123`.
 */
export function assetHasTranscript(assetId, assetIdsWithTranscript) {
  const id = normalizeAssetId(assetId)
  if (id == null) return false
  return (assetIdsWithTranscript || [])
    .map(normalizeAssetId)
    .filter((x) => x != null)
    .includes(id)
}
